import { Helmet } from "react-helmet";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import Pagebanner from "../../layout/Banner";
import ContactForm from "../../Components/HomeSections/ContactForm";

const ContactUS = () => {
  const brandGold = "#E3B66B";
  const darkGreen = "#0A1D1B";
  return (
    <>
      <Helmet>
        <title>Contact Us - Adv Akash Giri  Chambers</title>
        <meta
          name="description"
          content="Get in touch with  Adv Akash Giri  Chambers. Fill out our contact form to consult with our expert lawyers, ask questions, or request legal services."
        />
        <meta
          name="keywords"
          content="Contact  Adv Akash Giri , Legal Consultation, Law Firm Contact, Lawyer Inquiry, Legal Services Contact"
        />
        <noscript>
          Please enable JavaScript to view this website properly.
        </noscript>
      </Helmet>

      <Header />
      <Pagebanner title="Contact Us" />
      <ContactForm />

      {/* Map Section */}
      <section className={`bg-[${darkGreen}] py-12 px-6 md:px-12`}>
        <div
          className="max-w-7xl mx-auto rounded-lg overflow-hidden shadow-lg border-2"
          style={{ borderColor: brandGold }}
        >
          <iframe
            title=" Adv Akash Giri  Chambers Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.121199394683!2d77.29446177528997!3d28.656089475651818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfba3f3377785%3A0xd5c622854d83451e!2sAdvocate%20Akash%20Giri%20Goswami!5e0!3m2!1sen!2sin!4v1774505006781!5m2!1sen!2sin"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ContactUS;

